module.exports = __webpack_public_path__ + "static/media/10_tn.e6da8061.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/10_tn.jpg
// module id = 646
// module chunks = 0